import {Injectable} from '@angular/core'
import {HttpClient, HttpContext} from '@angular/common/http'
import {environment} from '../environments/environment'
import {SKIP_ERROR_INTERCEPTOR} from '../app/interceptors/error.interceptor';
import {User} from '../models/user';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
  }

  createCustomer(email: string, password: string, firstName: string, lastName: string, region: string, hometown: string | null, bypassErrorInterceptor = false) {
    const body = {email, password, firstName, lastName, region, hometown}
    const context = new HttpContext().set(SKIP_ERROR_INTERCEPTOR, bypassErrorInterceptor)
    return this.http.post<User>(`${API}/api/users`, body, {context})
  }

  createMerchant(email: string, password: string, firstName: string, lastName: string, region: string, inviteCode: string) {
    const body = {email, password, firstName, lastName, region, inviteCode}
    return this.http.post<User>(`${API}/api/users/merchant`, body)
  }

  createAdmin(email: string, password: string, firstName: string, lastName: string, region: string, inviteCode: string) {
    const body = {email, password, firstName, lastName, region, inviteCode}
    return this.http.post<User>(`${API}/api/users/admin`, body)
  }

  createEmployee(email: string, password: string, firstName: string, lastName: string, region: string, inviteCode: string) {
    const body = {email, password, firstName, lastName, region, inviteCode}
    return this.http.post<User>(`${API}/api/users/employee`, body)
  }

  getBySlug(slug: string) {
    return this.http.get<User>(`${API}/api/users/${slug}/slug`)
  }

  findByIds(userIds: string[], limit = 1000, skip = 0) {
    const params = {userIds, limit, skip}
    return this.http.get<User[]>(`${API}/api/users/userinfos`, {params})
  }

  findMerchants(limit = 1000, skip = 0) {
    const params = {limit, skip}
    return this.http.get<User[]>(`${API}/api/users/role/merchant`, {params})
  }

  findByCompanyId(companyId: string, limit = 1000, skip = 0) {
    const params = {limit, skip}
    return this.http.get<User[]>(`${API}/api/users/company/${companyId}`, {params})
  }

  search(search: string, limit = 1000, skip = 0) {
    const params = {search, limit, skip}
    return this.http.get(`${API}/api/users/search`, {params})
  }

  updateEmail(email: string) {
    const body = {email}
    return this.http.put(`${API}/api/users/email`, body)
  }

  updateImage(imageId: string) {
    const body = {imageId}
    return this.http.put(`${API}/api/users/image`, body)
  }

  updatePhoneNumber(phoneNumber: string) {
    const body = {phoneNumber}
    return this.http.put(`${API}/api/users/phonenumber`, body)
  }

  updateRegion(region: string) {
    const body = {region}
    return this.http.put(`${API}/api/users/region`, body)
  }

  updateInvoiceDetails(invoiceDetails: any) {
    const body = {invoiceDetails}
    return this.http.put(`${API}/api/users/invoicedetails`, body)
  }

  updateInformation(firstName: string, lastName: string) {
    const body = {firstName, lastName}
    return this.http.put(`${API}/api/users`, body)
  }

  updatePreference(preference: any) {
    const body = {preference}
    return this.http.put(`${API}/api/users/preference`, body)
  }

  updatePreferenceByUserId(userId: string, preference: any) {
    const body = {preference}
    return this.http.put(`${API}/api/users/${userId}/preference`, body)
  }

  updateEmailByUserId(userId: string, email: string) {
    const body = {email}
    return this.http.put(`${API}/api/users/${userId}/email`, body)
  }

  updateNameByUserId(userId: string, firstName: string, lastName: string) {
    const body = {firstName, lastName}
    return this.http.put(`${API}/api/users/${userId}/name`, body)
  }

  updateDetailsByUserId(userId: string, firstName: string, lastName: string, email: string, region: string, ref: string, invoiceDetails: any) {
    const body = {firstName, lastName, email, region, ref, invoiceDetails}
    return this.http.put(`${API}/api/users/${userId}/details`, body)
  }

  deactivate(userId: string) {
    return this.http.put(`${API}/api/users/${userId}/deactivate`, {})
  }

}
